import { useEffect, useState } from "react";

// Most searches finish in a few seconds, and large runs can take minutes.
export const SLOW_SEARCH_DELAY_MS = 10_000;

/** True once the current search has been loading for longer than `SLOW_SEARCH_DELAY_MS`. */
export const useSlowSearch = (isSearching: boolean, search: string) => {
  const [slowSearch, setSlowSearch] = useState<string | null>(null);

  useEffect(() => {
    if (!isSearching) return;
    const timer = setTimeout(() => setSlowSearch(search), SLOW_SEARCH_DELAY_MS);
    return () => {
      clearTimeout(timer);
      setSlowSearch(null);
    };
  }, [isSearching, search]);

  return isSearching && slowSearch === search;
};
